/**
 * Verticaly統一トースト通知システム v1.0
 * マイページ全体で使用する通知システム
 */

(function() {
  'use strict';

  // スタイルを動的に追加（1回のみ）
  if (!document.querySelector('#v0-notification-system-styles')) {
    const style = document.createElement('style');
    style.id = 'v0-notification-system-styles';
    style.textContent = `
      @keyframes v0-slideIn {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }

      @keyframes v0-slideOut {
        from {
          transform: translateX(0);
          opacity: 1;
        }
        to {
          transform: translateX(100%);
          opacity: 0;
        }
      }

      .v0-notification {
        position: fixed !important;
        top: 80px !important;
        right: 20px !important;
        padding: 18px 26px !important;
        border-radius: 16px !important;
        font-size: 15px !important;
        font-weight: 500 !important;
        letter-spacing: 0.3px !important;
        box-shadow:
          0 20px 50px rgba(0, 0, 0, 0.6),
          0 8px 16px rgba(0, 0, 0, 0.4),
          inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;
        z-index: 999999 !important;
        animation: v0-slideIn 0.3s ease-out !important;
        max-width: 400px !important;
        min-width: 280px !important;
        opacity: 1 !important;
        display: flex !important;
        align-items: center !important;
        gap: 12px !important;
        color: white !important;
        border: 1px solid rgba(255, 255, 255, 0.08) !important;
        backdrop-filter: blur(10px) !important;
      }

      .v0-notification--success {
        background: linear-gradient(135deg, #000000 0%, #1a1a1a 100%) !important;
      }

      .v0-notification--error {
        background: linear-gradient(135deg, #000000 0%, #1a1a1a 100%) !important;
      }

      .v0-notification--warning {
        background: linear-gradient(135deg, #000000 0%, #1a1a1a 100%) !important;
      }

      .v0-notification--info {
        background: linear-gradient(135deg, #000000 0%, #1a1a1a 100%) !important;
      }

      .v0-notification svg {
        flex-shrink: 0;
      }

      @media (max-width: 768px) {
        .v0-notification {
          top: 10px !important;
          right: 10px !important;
          left: 10px !important;
          max-width: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  // グローバル通知関数
  window.V0Notification = {
    /**
     * 通知を表示
     * @param {string} message - 表示するメッセージ
     * @param {string} type - 通知タイプ ('success', 'error', 'warning', 'info')
     * @param {number} duration - 表示時間（ミリ秒、デフォルト: success=3000, error=5000, other=4000）
     */
    show: function(message, type = 'info', duration = null) {
      // 既存の通知を削除
      const existingNotification = document.querySelector('.v0-notification');
      if (existingNotification) {
        existingNotification.remove();
      }

      // アイコンを選択
      const icons = {
        success: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"></path></svg>',
        error: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>',
        warning: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>',
        info: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>'
      };

      // デフォルトの表示時間
      if (!duration) {
        duration = type === 'success' ? 3000 : type === 'error' ? 5000 : 4000;
      }

      // 通知要素を作成
      const notification = document.createElement('div');
      notification.className = `v0-notification v0-notification--${type}`;
      notification.innerHTML = `
        ${icons[type] || icons.info}
        <span>${message}</span>
      `;

      document.body.appendChild(notification);

      // 自動削除
      const timerId = setTimeout(() => {
        if (notification && notification.parentNode) {
          notification.style.animation = 'v0-slideOut 0.3s ease-out';
          setTimeout(() => {
            if (notification && notification.parentNode) {
              notification.remove();
            }
          }, 300);
        }
      }, duration);

      // クリックで即座に削除
      notification.addEventListener('click', () => {
        clearTimeout(timerId);
        notification.style.animation = 'v0-slideOut 0.3s ease-out';
        setTimeout(() => {
          if (notification && notification.parentNode) {
            notification.remove();
          }
        }, 300);
      });

    },

    success: function(message, duration) {
      this.show(message, 'success', duration);
    },

    error: function(message, duration) {
      this.show(message, 'error', duration);
    },

    warning: function(message, duration) {
      this.show(message, 'warning', duration);
    },

    info: function(message, duration) {
      this.show(message, 'info', duration);
    }
  };

})();
